import _merge from 'lodash/merge';
import React, { useContext } from 'react';
import { Manulife, ManulifeFr } from '@manulife/mux-logos';
import PropTypes from '../../../node_modules/prop-types/index.js';
import Button from '../Button/index.js';
import i18n from '../../lang/i18n/index.js';
import LANG from '../../lang/lang.js';
import { BREAKPOINTS } from '../../spacing/index.js';
import { MOBILE_MENU_VARIANT } from './constants.js';
import SideNavContext from './SideNavContext.js';
import { MobileSubNavWrapper, MobileHeaderItem, SubNavList, SubNavWrapper, WordmarkLogoComponent } from './styledComponents.js';
import { addRefToFirstChild } from './utils.js';
import useTheme from '../../hooks/useTheme.js';
import useLang from '../../hooks/useLang.js';
import useNavigation from '../../hooks/useNavigation.js';
import useMedia from '../../hooks/useMedia.js';
import { BUTTON_VARIANT } from '../Button/constants.js';

var SubNav = function SubNav(_ref) {
  var _logo$props;

  var id = _ref.id,
      isSubNavExpanded = _ref.isSubNavExpanded,
      backButtonLabel = _ref.backButtonLabel,
      children = _ref.children;
  var theme = useTheme();
  var lang = useLang();

  var _useNavigation = useNavigation(),
      subNavWrapperRef = _useNavigation.subNavWrapperRef;

  var _useContext = useContext(SideNavContext),
      logo = _useContext.logo,
      wordmarkLogoProps = _useContext.wordmarkLogoProps,
      isWideMainNav = _useContext.isWideMainNav,
      isMobileNavExpanded = _useContext.isMobileNavExpanded,
      setExpandedParentKey = _useContext.setExpandedParentKey,
      subNavRef = _useContext.subNavRef;

  var showHamburgerMenu = useMedia(["(max-width: ".concat(BREAKPOINTS.MAX_1024, "px)")], // media queries
  [true], // values corresponding to media query
  false // default value
  );
  var alt = wordmarkLogoProps.alt,
      href = wordmarkLogoProps.href,
      onClick = wordmarkLogoProps.onClick;

  var logoStyle = _merge({}, {
    // Set defaults from theme
    height: theme.sideNav.wordmarkLogo.height,
    maxWidth: theme.sideNav.wordmarkLogo.maxWidth
  }, logo === null || logo === void 0 ? void 0 : (_logo$props = logo.props) === null || _logo$props === void 0 ? void 0 : _logo$props.style // Override with user-provided styles via the logo component
  );

  var DefaultLogo = lang === LANG.EN_CA ? /*#__PURE__*/React.createElement(Manulife.WORDMARK_BLACK, {
    id: "wordmark-logo",
    "data-testid": "wordmark-logo"
  }) : /*#__PURE__*/React.createElement(ManulifeFr.WORDMARK_BLACK, {
    id: "wordmark-logo",
    "data-testid": "wordmark-logo"
  });
  var Logo = logo || DefaultLogo;
  var WordmarkLogo = /*#__PURE__*/React.cloneElement(Logo, {
    title: alt || i18n[lang].sideNav.wordmarkLogo,
    style: logoStyle
  }, null);
  return showHamburgerMenu ? /*#__PURE__*/React.createElement(MobileSubNavWrapper, {
    id: "sub-nav-".concat(id),
    "data-testid": "sub-nav-".concat(id),
    isSubNavExpanded: isSubNavExpanded,
    isMobileNavExpanded: isMobileNavExpanded,
    theme: theme
  }, theme.sideNav.mobile.variant === MOBILE_MENU_VARIANT.OVERLAY && /*#__PURE__*/React.createElement(MobileHeaderItem, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "back-button-".concat(id),
    variant: BUTTON_VARIANT.TERTIARY_BACK,
    customStyle: {
      buttonStyle: {
        paddingLeft: '14px',
        height: '100%'
      }
    },
    onClick: function onClick() {
      return setExpandedParentKey();
    }
  }, backButtonLabel)), /*#__PURE__*/React.createElement(SubNavList, {
    role: "menu"
  }, children)) : isSubNavExpanded && /*#__PURE__*/React.createElement(SubNavWrapper, {
    ref: subNavWrapperRef,
    id: "sub-nav-".concat(id),
    "data-testid": "sub-nav-".concat(id),
    isWideMainNav: isWideMainNav,
    theme: theme
  }, /*#__PURE__*/React.createElement(WordmarkLogoComponent, {
    href: href,
    onClick: onClick,
    theme: theme,
    isWideMainNav: isWideMainNav
  }, WordmarkLogo), /*#__PURE__*/React.createElement(SubNavList, {
    role: "menu"
  }, addRefToFirstChild(children, subNavRef)));
};

process.env.NODE_ENV !== "production" ? SubNav.propTypes = {
  id: PropTypes.string,
  isSubNavExpanded: PropTypes.bool,
  backButtonLabel: PropTypes.node,
  children: PropTypes.node.isRequired
} : void 0;
SubNav.defaultProps = {
  id: undefined,
  isSubNavExpanded: false,
  backButtonLabel: undefined
};
process.env.NODE_ENV !== "production" ? SubNav.displayName = 'SubNav' : void 0;
var SubNav$1 = SubNav;

export { SubNav$1 as default };
